var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.isBusy,
              expression: "isBusy",
            },
          ],
          ref: "form",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "element-loading-spinner": "el-icon-loading",
            "label-width": "170px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "Title", prop: "title" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.form.title,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "title", $$v)
                  },
                  expression: "form.title",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "Description", prop: "description" } },
            [
              _c("el-input", {
                attrs: { type: "textarea" },
                model: {
                  value: _vm.form.description,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "description", $$v)
                  },
                  expression: "form.description",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "File:", prop: "file" } },
            [
              !_vm.isEditMode
                ? _c("audio-file-input", {
                    model: {
                      value: _vm.form.file,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "file", $$v)
                      },
                      expression: "form.file",
                    },
                  })
                : _c("file-item", {
                    attrs: { metadata: _vm.model.metadata, url: _vm.model.url },
                  }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "Shared", prop: "shared" } },
            [
              _c("el-switch", {
                attrs: { type: "text", "active-value": 1, "inactive-value": 0 },
                model: {
                  value: _vm.form.shared,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "shared", $$v)
                  },
                  expression: "form.shared",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-button",
        { attrs: { type: "primary" }, on: { click: _vm.store } },
        [_vm._v("Save")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }